import { ApiUtil as api } from '@/utils/api.util.js'

export class AssociatedService {

    static URL = process.env.API_URL + process.env.API_VER

    static RESOURCE = '/firms/'    

    static firmFirm (queryParams = {}) {

        return api.get(this.URL + this.RESOURCE + 'get/firm_firm', queryParams)

    }

    static firmFirmCode (queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'get/firm_firm/code', queryParams)
    }

	static archive (queryParams = {}) {
		
        return api.put(this.URL + this.RESOURCE + 'archive/firm_firm', queryParams)
	
	}

	static update (queryParams = {}) {
		
        return api.put(this.URL + this.RESOURCE + 'update/firm_firm', queryParams)
	
	}

	static updateFirmName (queryParams = {}) {
		
        return api.put(this.URL + this.RESOURCE + 'update/firm_name', queryParams)
	
	}

	static delete (queryParams = {}) {
		
        return api.put(this.URL + this.RESOURCE + 'delete/firm_firm', queryParams)
	
	}
	static getTags (queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + 'get/tags', queryParams)
	}
	static attachTag (queryParams = {}) {
		return api.post(this.URL + this.RESOURCE + 'attach/tag', queryParams)
	}
	static getAssociated (queryParams = {}) {
		return api.get(this.URL + this.RESOURCE + 'associated/ids', queryParams)
	}

	static toggleArchive (queryParams = {}) {
		return api.put(this.URL + this.RESOURCE + 'associated/toggle/archive', queryParams)
	}

}






// WEBPACK FOOTER //
// ./src/services/associated.service.js